const gsap = require("gsap");
export const loaderGsap = (tl) => {
  tl.to(".firstText", {
    opacity: 1,
    duration: 2,
    stagger: 0.5,
    ease: "power2.inOut",
  });
  tl.to(".firstText", {
    opacity: 0,
    duration: 1,
    ease: "power2.inOut",
  });
  tl.to(".loader", {
    borderBottomLeftRadius: "80%",
    borderBottomRightRadius: "80%",
    height: 0,
    display: false,
    duration: 2,
    ease: "power2.inOut",
  });
  tl.set(".loader", { display: "none" });
  tl.to(".loader2", {
    borderBottomLeftRadius: "80%",
    borderBottomRightRadius: "80%",
    height: 0,
    display: false,
    duration: 2,
    ease: "power2.inOut",
  });
  tl.set(".loader2", { display: "none" });
  tl.to(".loader3", {
    borderBottomLeftRadius: "80%",
    borderBottomRightRadius: "80%",
    height: 0,
    duration: 2,
    ease: "power2.inOut",
  });
  tl.set(".loader3", { display: "none" }, "-=.5");
  tl.to(
    ".desktopNav",
    {
      y: "0%",
      duration: 2,
      ease: "power2.inOut",
    },
    "-=1"
  );
  tl.to(
    ".heroHeader",
    {
      y: "0%",
      opacity: 100,
      duration: 2,
      ease: "power2.inOut",
    },
    "-=1"
  );
  tl.fromTo(
    "header",
    {
      y: "-200px",
    },
    {
      y: "0px",
      opacity: 100,
      duration: 3,
      ease: "power2.inOut",
    },
    "-=2"
  );
  // Animate the "KARIM" span
  tl.fromTo(
    ".animation-2",
    {
      opacity: 0,
      y: "100%",
      duration: 1,
      ease: "power2.inOut",
    },
    {
      opacity: 1,
      y: "10%",
      duration: 1,
      ease: "power2.inOut",
    },
    "-=3"
  );
};
